import config from '@/config';
import taskMessages from '@/modules/tasks/taskMessages';
import api from '@/shared/api';
import handleHttpError from '@/shared/services/HandleHttpError';
import ToastrService from '@/shared/services/ToastrService';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { TaskQueryKey } from './queryKey';
export const useDeletePlannedTask = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading, error } = useMutation(values => api.base
        .delete(`${config.appUrls.tasks}/api/plannedTasks/${values.taskId}`, {
        params: { taskLevel: values.taskLevel },
    })
        .then(res => res.data), {
        onSuccess: () => {
            queryClient.invalidateQueries([TaskQueryKey.PlannedTasks]);
            ToastrService.success(intl.formatMessage(taskMessages.TaskDeleted));
        },
        onError: e => {
            handleHttpError(intl)(e);
        },
    });
    return {
        deletePlannedTask: mutateAsync,
        isLoading,
        error,
    };
};
